import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
// components
import { Card, CardHeader, CardText } from 'material-ui/Card';
import LaunchIcon from 'material-ui/svg-icons/action/launch';
import SubjectIcon from 'material-ui/svg-icons/action/subject';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import VideoIcon from 'material-ui/svg-icons/av/video-library';
import AudioIcon from 'material-ui/svg-icons/av/library-music';
import ImageIcon from 'material-ui/svg-icons/image/image';
import * as Colors from 'material-ui/styles/colors';

import Markdown from 'react-markdown';
import { DateStyles } from '../../constants/CentricConstants';
import { isSurroundedBy } from '../../utils/StringUtils';

const getAvatar = ({type}) => {
    switch (type) {

        case 'text':
            return (<SubjectIcon  color={Colors.grey400}/>);

        case 'document':
            return (<LibraryIcon  color={Colors.grey400}/>);

        case 'image':
            return (<ImageIcon  color={Colors.grey400}/>);

        case 'video':
            return (<VideoIcon  color={Colors.grey400}/>);

        case 'audio':
            return (<AudioIcon  color={Colors.grey400}/>);

        case 'e-learning':
            return (<LaunchIcon  color={Colors.grey400}/>);

        default:
            return <LibraryIcon  color={Colors.grey400}/>;
    }
};

class AssetCard extends Component {

    render() {
        let url = this.props.url.replace('{id}', this.props.data.id);
        let text = '';
        if (!!this.props.search && !!this.props.data.rawContent) {
            const search = isSurroundedBy(this.props.search, '"') ? this.props.search.substring(1, this.props.search.length - 1) : this.props.search.replace(/\s+/g, '|');
            const textSegment = this.props.data.rawContent.match(RegExp(`[^.?!]*(${search})[^.?!]*([.?!]|$)`, 'gi'));
            if (textSegment) {
                text = textSegment.join(' [...] ')
                    .replace(RegExp(search, 'gi'), '<span class="search-term">**$&**</span>')
                    .replace(/\n/g, ' ');
            }
        } else if (!!this.props.data.content) {
            text = this.props.data.content;
        }
        let subtitle = this.props.data.code;
        const validFrom = new Date(this.props.data.validFrom);
        if (!!validFrom && !isNaN(validFrom.valueOf())) {
            subtitle += ` - ${validFrom.toLocaleString('en-GB', DateStyles.shortWeekday)}`;
        }

        return (
            <Card className="cent-card" key={this.props.data.id}>
                <Link to={url}>
                    <CardHeader
                        title={this.props.data.name}
                        subtitle={subtitle}
                        avatar={getAvatar(this.props.data)}
                    />
                </Link>
                <CardText>
                    <Markdown source={text} />
                </CardText>
            </Card>
        );
    }

}

AssetCard.propTypes = {
    data:       PropTypes.shape({
        id:         PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name:       PropTypes.string.isRequired,
        code:       PropTypes.string,
        content:    PropTypes.string,
        rawContent: PropTypes.string
    }).isRequired,
    search:     PropTypes.string,
    url:        PropTypes.string
};

AssetCard.defaultProps = {
    url:        '/dashboard/asset/{id}'
};

export default AssetCard;
